export default "__VITE_ASSET__CcLfsoGh__"